const initialState = {
    data: null,
    count: null,
};
export const DeleteMoreThanOneDocumentReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DELETEMORETHANONEDOCUMENT_SUCCESS':
            return {
                ...state,
                data: action.payload,
                count: action.count,
            };
        case 'DELETEMORETHANONEDOCUMENT_FAILURE':
            return {
                ...state,
                error: action.payload,
            };
        case 'DELETEMORETHANONEDOCUMENT_RESET':
            return initialState;
        default:
            return state;
    }
}

export default DeleteMoreThanOneDocumentReducer;